import { auth } from './firebase';

// The server rejects any /api request without a Firebase ID token. Rather than
// touching ~30 call sites spread across the app, patch fetch once so every
// relative /api request carries the signed-in user's token. Absolute URLs and
// non-API requests are passed straight through.
const nativeFetch = window.fetch.bind(window);

function isApiRequest(input) {
  const url = typeof input === 'string' ? input : (input && input.url) || '';
  return url.startsWith('/api');
}

async function withAuthHeaders(init) {
  const user = auth.currentUser;
  if (!user) return init;
  const headers = new Headers(init.headers || {});
  headers.set('Authorization', `Bearer ${await user.getIdToken()}`);
  return { ...init, headers };
}

window.fetch = async (input, init = {}) => {
  if (!isApiRequest(input)) return nativeFetch(input, init);
  return nativeFetch(input, await withAuthHeaders(init));
};

// Anchor navigations can't carry an Authorization header, so authenticated file
// downloads have to go through fetch and be handed to the browser as a blob.
export async function downloadFile(url, filename) {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Download failed (HTTP ${res.status})`);
  }
  const blobUrl = URL.createObjectURL(await res.blob());
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(blobUrl);
}
